import { DirectiveOptions } from 'vue'

export const VVtFocus: DirectiveOptions = {
    inserted: (el: HTMLElement) => el.focus()
}
